export default __webpack_public_path__ + "maps-examples-source-custom-raster-thumbnail-480-67cebe17b434e2c62375ca6d8f07afe1.png";